"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileJobChecklistErrorCodeV1Schema = exports.mobileAppointmentStatusErrorCodeV1Schema = exports.mobileAddJobNoteResponseV1Schema = exports.mobileAddJobNoteRequestV1Schema = exports.mobileUpdateJobChecklistItemResponseV1Schema = exports.mobileUpdateAppointmentStatusResponseV1Schema = exports.mobileTechnicianTimeActionResponseV1Schema = exports.mobileAssignedWorkDetailSchema = exports.mobileWorkActivitySchema = exports.mobileWorkFinancialSummarySchema = exports.mobileFieldEstimateResponseV1Schema = exports.mobileSendEstimateRequestV1Schema = exports.mobileCaptureEstimateSignatureRequestV1Schema = exports.mobileCreateEstimateFromJobRequestV1Schema = exports.mobileFieldEstimateSchema = exports.mobileFieldEstimateStatusSchema = exports.mobileJobLineMutationResponseV1Schema = exports.mobileUpdateJobLineRequestV1Schema = exports.mobileAddJobLineRequestV1Schema = exports.mobilePriceBookResponseV1Schema = exports.mobilePriceBookQuerySchema = exports.mobilePriceBookItemSchema = exports.mobileCustomerPropertyContextSchema = exports.mobilePreviousJobSchema = exports.mobilePropertyEquipmentSchema = exports.mobileTechnicianTimeActionRequestV1Schema = exports.mobileTechnicianTimeSummarySchema = exports.mobileTechnicianTimeEntrySchema = exports.mobileTechnicianTimeActionV1Schema = exports.mobileTechnicianPauseReasonSchema = exports.mobileAssignedWorkCapabilitiesSchema = exports.mobileWorkLineSchema = exports.mobileTodayAssignedWorkResponseSchema = exports.mobileAssignedWorkListResponseSchema = exports.mobileAssignedWorkItemSchema = exports.mobileWorkAppointmentSchema = exports.mobileUpdateAppointmentStatusRequestV1Schema = exports.mobileAppointmentAvailableActionV1Schema = exports.mobileAppointmentActionV1Schema = exports.MOBILE_FIELD_ESTIMATE_CONTRACT_VERSION = exports.MOBILE_JOB_LINE_CONTRACT_VERSION = exports.MOBILE_PRICE_BOOK_CONTRACT_VERSION = exports.MOBILE_TECHNICIAN_TIME_CONTRACT_VERSION = exports.MOBILE_JOB_NOTE_CONTRACT_VERSION = exports.MOBILE_JOB_CHECKLIST_CONTRACT_VERSION = exports.MOBILE_APPOINTMENT_ACTION_CONTRACT_VERSION = exports.mobileWorkLocationSchema = exports.mobileWorkCustomerSchema = exports.mobileAssignedWorkListQuerySchema = exports.mobileAssignedWorkViewSchema = void 0;
const zod_1 = require("zod");
const job_1 = require("./job");
const job_checklist_1 = require("./job-checklist");
const pagination_1 = require("./pagination");
const team_1 = require("./team");
const marketing_attribution_1 = require("./marketing-attribution");
exports.mobileAssignedWorkViewSchema = zod_1.z.enum([
    "TODAY",
    "UPCOMING",
    "COMPLETED",
]);
exports.mobileAssignedWorkListQuerySchema = pagination_1.paginationQuerySchema.extend({
    view: exports.mobileAssignedWorkViewSchema.default("TODAY"),
});
exports.mobileWorkCustomerSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    displayName: zod_1.z.string(),
    email: zod_1.z.string().email().nullable().default(null),
    phone: zod_1.z.string().nullable(),
});
exports.mobileWorkLocationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    addressLine1: zod_1.z.string(),
    addressLine2: zod_1.z.string().nullable(),
    city: zod_1.z.string(),
    state: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    timezone: zod_1.z.string(),
    accessNotes: zod_1.z.string().nullable().default(null),
});
exports.MOBILE_APPOINTMENT_ACTION_CONTRACT_VERSION = 1;
exports.MOBILE_JOB_CHECKLIST_CONTRACT_VERSION = 1;
exports.MOBILE_JOB_NOTE_CONTRACT_VERSION = 1;
exports.MOBILE_TECHNICIAN_TIME_CONTRACT_VERSION = 1;
exports.MOBILE_PRICE_BOOK_CONTRACT_VERSION = 1;
exports.MOBILE_JOB_LINE_CONTRACT_VERSION = 1;
exports.MOBILE_FIELD_ESTIMATE_CONTRACT_VERSION = 1;
exports.mobileAppointmentActionV1Schema = zod_1.z.enum([
    "ON_MY_WAY",
    "START_JOB",
    "COMPLETE_JOB",
]);
exports.mobileAppointmentAvailableActionV1Schema = zod_1.z.object({
    action: exports.mobileAppointmentActionV1Schema,
    label: zod_1.z.string().min(1),
    targetStatus: zod_1.z.enum(["EN_ROUTE", "IN_PROGRESS", "COMPLETED"]),
    requiresConfirmation: zod_1.z.boolean(),
});
exports.mobileUpdateAppointmentStatusRequestV1Schema = zod_1.z.object({
    action: exports.mobileAppointmentActionV1Schema,
});
exports.mobileWorkAppointmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    status: job_1.appointmentStatusSchema,
    assignee: team_1.teamMemberSchema.nullable(),
    availableActions: zod_1.z.array(exports.mobileAppointmentAvailableActionV1Schema),
});
exports.mobileAssignedWorkItemSchema = zod_1.z.object({
    jobId: job_1.jobIdSchema,
    jobNumber: zod_1.z.number().int().positive(),
    summary: zod_1.z.string(),
    status: job_1.jobStatusSchema,
    priority: job_1.jobPrioritySchema,
    customer: exports.mobileWorkCustomerSchema,
    serviceLocation: exports.mobileWorkLocationSchema,
    primaryAppointment: exports.mobileWorkAppointmentSchema.nullable(),
    assignmentState: zod_1.z.enum(["ASSIGNED", "UNASSIGNED"]),
    updatedAt: zod_1.z.string().datetime(),
});
exports.mobileAssignedWorkListResponseSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    view: exports.mobileAssignedWorkViewSchema,
    items: zod_1.z.array(exports.mobileAssignedWorkItemSchema),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.mobileTodayAssignedWorkResponseSchema = zod_1.z.object({
    timezone: zod_1.z.string(),
    dayStartsAt: zod_1.z.string().datetime(),
    dayEndsAt: zod_1.z.string().datetime(),
    generatedAt: zod_1.z.string().datetime(),
    current: zod_1.z.array(exports.mobileAssignedWorkItemSchema),
    next: exports.mobileAssignedWorkItemSchema.nullable(),
    upcoming: zod_1.z.array(exports.mobileAssignedWorkItemSchema),
    completed: zod_1.z.array(exports.mobileAssignedWorkItemSchema),
    unassigned: zod_1.z.array(exports.mobileAssignedWorkItemSchema),
});
exports.mobileWorkLineSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid().nullable().default(null),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]).default("SERVICE"),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]).default("FLAT_RATE"),
    quantityMilli: zod_1.z.number().int().positive(),
    unitDurationMinutes: zod_1.z
        .number()
        .int()
        .min(5)
        .max(1_440)
        .nullable()
        .default(null),
    notes: zod_1.z.string().max(2_000).nullable().default(null),
    unitPriceCents: zod_1.z.number().int().nonnegative().nullable().default(null),
    lineTotalCents: zod_1.z.number().int().nonnegative().nullable(),
    priceBookVersionId: zod_1.z.string().uuid().nullable().optional(),
});
exports.mobileAssignedWorkCapabilitiesSchema = zod_1.z.object({
    canTrackTime: zod_1.z.boolean(),
    canEditJobLines: zod_1.z.boolean(),
    canViewPrices: zod_1.z.boolean(),
    canManageInvoice: zod_1.z.boolean(),
    canCollectPrepayment: zod_1.z.boolean(),
    canCreateEstimate: zod_1.z.boolean(),
    canCaptureSignature: zod_1.z.boolean(),
    canSendEstimate: zod_1.z.boolean(),
});
exports.mobileTechnicianPauseReasonSchema = zod_1.z.enum([
    "BREAK",
    "WAITING_FOR_PARTS",
    "CUSTOMER_DELAY",
    "OTHER",
]);
exports.mobileTechnicianTimeActionV1Schema = zod_1.z.enum([
    "START_TRAVEL",
    "START_WORK",
    "PAUSE_WORK",
    "RESUME_WORK",
    "COMPLETE_WORK",
]);
exports.mobileTechnicianTimeEntrySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    appointmentId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    technicianName: zod_1.z.string().nullable(),
    kind: zod_1.z.enum(["TRAVEL", "WORK"]),
    startedAt: zod_1.z.string().datetime(),
    endedAt: zod_1.z.string().datetime().nullable(),
    stopReason: zod_1.z
        .enum(["STARTED_WORK", "PAUSED", "COMPLETED", "STOPPED"])
        .nullable(),
    pauseReason: exports.mobileTechnicianPauseReasonSchema.nullable(),
    pauseNote: zod_1.z.string().nullable(),
    durationSeconds: zod_1.z.number().int().nonnegative(),
});
exports.mobileTechnicianTimeSummarySchema = zod_1.z.object({
    serverNow: zod_1.z.string().datetime(),
    state: zod_1.z.enum(["IDLE", "TRAVELING", "WORKING", "PAUSED", "COMPLETED"]),
    activeEntry: exports.mobileTechnicianTimeEntrySchema.nullable(),
    travelSeconds: zod_1.z.number().int().nonnegative(),
    workSeconds: zod_1.z.number().int().nonnegative(),
    availableActions: zod_1.z.array(exports.mobileTechnicianTimeActionV1Schema),
    entries: zod_1.z.array(exports.mobileTechnicianTimeEntrySchema),
});
exports.mobileTechnicianTimeActionRequestV1Schema = zod_1.z
    .object({
    action: exports.mobileTechnicianTimeActionV1Schema,
    pauseReason: exports.mobileTechnicianPauseReasonSchema.optional(),
    pauseNote: zod_1.z.string().trim().max(500).optional(),
})
    .superRefine((value, context) => {
    if (value.action === "PAUSE_WORK" && !value.pauseReason) {
        context.addIssue({
            code: "custom",
            path: ["pauseReason"],
            message: "A pause reason is required when pausing work.",
        });
    }
    if (value.action !== "PAUSE_WORK" && value.pauseReason) {
        context.addIssue({
            code: "custom",
            path: ["pauseReason"],
            message: "Pause reason is only valid when pausing work.",
        });
    }
});
exports.mobilePropertyEquipmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    manufacturer: zod_1.z.string().nullable(),
    model: zod_1.z.string().nullable(),
    serialNumber: zod_1.z.string().nullable(),
    installedAt: zod_1.z.string().datetime().nullable(),
    notes: zod_1.z.string().nullable(),
});
exports.mobilePreviousJobSchema = zod_1.z.object({
    jobId: job_1.jobIdSchema,
    jobNumber: zod_1.z.number().int().positive(),
    summary: zod_1.z.string(),
    status: job_1.jobStatusSchema,
    completedAt: zod_1.z.string().datetime().nullable(),
    totalCents: zod_1.z.number().int().nonnegative().nullable(),
});
exports.mobileCustomerPropertyContextSchema = zod_1.z.object({
    customerSince: zod_1.z.string().datetime(),
    completedJobCount: zod_1.z.number().int().nonnegative(),
    totalJobCount: zod_1.z.number().int().nonnegative(),
    previousJobs: zod_1.z.array(exports.mobilePreviousJobSchema),
    equipment: zod_1.z.array(exports.mobilePropertyEquipmentSchema),
});
exports.mobilePriceBookItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    code: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]),
    category: zod_1.z.object({ id: zod_1.z.string().uuid(), name: zod_1.z.string() }).nullable(),
    estimatedDurationMinutes: zod_1.z.number().int().nonnegative().nullable(),
    unitPriceCents: zod_1.z.number().int().nonnegative().nullable(),
});
exports.mobilePriceBookQuerySchema = zod_1.z.object({
    search: zod_1.z.string().trim().max(120).default(""),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]).optional(),
});
exports.mobilePriceBookResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_PRICE_BOOK_CONTRACT_VERSION),
    pricesVisible: zod_1.z.boolean(),
    publishedVersion: zod_1.z
        .object({
        id: zod_1.z.string().uuid(),
        versionNumber: zod_1.z.number().int().positive(),
        scopeType: zod_1.z.enum(["ORGANIZATION_DEFAULT", "LOCATION_OVERRIDE"]),
        locationId: zod_1.z.string().uuid().nullable(),
        effectiveAt: zod_1.z.string().datetime(),
        publishedAt: zod_1.z.string().datetime(),
        inheritedFromVersionId: zod_1.z.string().uuid().nullable(),
    })
        .nullable()
        .optional(),
    freshness: zod_1.z
        .object({
        generatedAt: zod_1.z.string().datetime(),
        maxAgeSeconds: zod_1.z.number().int().positive(),
    })
        .optional(),
    items: zod_1.z.array(exports.mobilePriceBookItemSchema),
});
exports.mobileAddJobLineRequestV1Schema = zod_1.z.object({
    catalogItemId: zod_1.z.string().uuid(),
    quantityMilli: zod_1.z.number().int().min(1).max(1_000_000).default(1_000),
});
exports.mobileUpdateJobLineRequestV1Schema = zod_1.z.object({
    quantityMilli: zod_1.z.number().int().min(1).max(1_000_000),
});
exports.mobileJobLineMutationResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_LINE_CONTRACT_VERSION),
    job: zod_1.z.lazy(() => exports.mobileAssignedWorkDetailSchema),
});
exports.mobileFieldEstimateStatusSchema = zod_1.z.enum([
    "DRAFT",
    "SENT",
    "ACCEPTED",
    "DECLINED",
]);
exports.mobileFieldEstimateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    estimateNumber: zod_1.z.number().int().positive(),
    status: exports.mobileFieldEstimateStatusSchema,
    currentVersionNumber: zod_1.z.number().int().nonnegative(),
    customerName: zod_1.z.string(),
    recipientName: zod_1.z.string().nullable(),
    recipientEmail: zod_1.z.string().email().nullable(),
    recipientPhone: zod_1.z.string().nullable(),
    notes: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.mobileWorkLineSchema.extend({
        catalogItemId: zod_1.z.string().uuid(),
        unitPriceCents: zod_1.z.number().int().nonnegative().nullable(),
        lineTotalCents: zod_1.z.number().int().nonnegative().nullable(),
    })),
    subtotalCents: zod_1.z.number().int().nonnegative().nullable(),
    taxCents: zod_1.z.number().int().nonnegative().nullable(),
    totalCents: zod_1.z.number().int().nonnegative().nullable(),
    presentedAt: zod_1.z.string().datetime().nullable(),
    signedAt: zod_1.z.string().datetime().nullable(),
    signerName: zod_1.z.string().nullable(),
});
exports.mobileCreateEstimateFromJobRequestV1Schema = zod_1.z.object({
    notes: zod_1.z.string().trim().max(5_000).optional(),
    expiresAt: zod_1.z.string().datetime().optional(),
});
exports.mobileCaptureEstimateSignatureRequestV1Schema = zod_1.z.object({
    signerName: zod_1.z.string().trim().min(2).max(160),
    consentAccepted: zod_1.z.literal(true),
});
exports.mobileSendEstimateRequestV1Schema = zod_1.z.object({
    channel: zod_1.z.enum(["EMAIL", "SMS"]).optional(),
});
exports.mobileFieldEstimateResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_FIELD_ESTIMATE_CONTRACT_VERSION),
    estimate: exports.mobileFieldEstimateSchema,
    job: zod_1.z.lazy(() => exports.mobileAssignedWorkDetailSchema),
});
exports.mobileWorkFinancialSummarySchema = zod_1.z.object({
    prepaymentBasisAmountCents: zod_1.z
        .number()
        .int()
        .nonnegative()
        .nullable()
        .default(null),
    sourceEstimate: zod_1.z
        .object({
        id: zod_1.z.string().uuid(),
    })
        .nullable(),
    fieldEstimate: zod_1.z
        .object({
        id: zod_1.z.string().uuid(),
        estimateNumber: zod_1.z.number().int().positive(),
        status: exports.mobileFieldEstimateStatusSchema,
    })
        .nullable(),
    invoice: zod_1.z
        .object({
        id: zod_1.z.string().uuid(),
        invoiceNumber: zod_1.z.number().int().positive(),
        status: zod_1.z.enum(["DRAFT", "OPEN", "VOID"]),
        totalCents: zod_1.z.number().int().nonnegative(),
        paidCents: zod_1.z.number().int().nonnegative(),
        outstandingCents: zod_1.z.number().int().nonnegative(),
    })
        .nullable(),
});
exports.mobileWorkActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    title: zod_1.z.string(),
    actorName: zod_1.z.string().nullable(),
    occurredAt: zod_1.z.string().datetime(),
    kind: zod_1.z.enum(["EVENT", "NOTE"]).default("EVENT"),
    detail: zod_1.z.string().nullable().default(null),
});
exports.mobileAssignedWorkDetailSchema = exports.mobileAssignedWorkItemSchema
    .omit({ primaryAppointment: true, assignmentState: true })
    .extend({
    description: zod_1.z.string().nullable(),
    internalNote: zod_1.z.string().nullable(),
    appointments: zod_1.z.array(exports.mobileWorkAppointmentSchema),
    lines: zod_1.z.array(exports.mobileWorkLineSchema),
    team: zod_1.z.array(team_1.teamMemberSchema),
    financials: exports.mobileWorkFinancialSummarySchema,
    activity: zod_1.z.array(exports.mobileWorkActivitySchema),
    checklistCompletion: job_checklist_1.jobChecklistCompletionSchema,
    checklists: zod_1.z.array(job_checklist_1.jobChecklistSchema),
    capabilities: exports.mobileAssignedWorkCapabilitiesSchema,
    timeTracking: exports.mobileTechnicianTimeSummarySchema,
    customerProperty: exports.mobileCustomerPropertyContextSchema,
    attribution: marketing_attribution_1.marketingAttributionSummarySchema.nullable().optional(),
});
exports.mobileTechnicianTimeActionResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_TECHNICIAN_TIME_CONTRACT_VERSION),
    changed: zod_1.z.boolean(),
    job: exports.mobileAssignedWorkDetailSchema,
});
exports.mobileUpdateAppointmentStatusResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_APPOINTMENT_ACTION_CONTRACT_VERSION),
    changed: zod_1.z.boolean(),
    appointment: exports.mobileWorkAppointmentSchema,
    job: exports.mobileAssignedWorkDetailSchema,
});
exports.mobileUpdateJobChecklistItemResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_CHECKLIST_CONTRACT_VERSION),
    job: exports.mobileAssignedWorkDetailSchema,
});
exports.mobileAddJobNoteRequestV1Schema = zod_1.z.object({
    note: zod_1.z.string().trim().min(1).max(2_000),
});
exports.mobileAddJobNoteResponseV1Schema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.MOBILE_JOB_NOTE_CONTRACT_VERSION),
    job: exports.mobileAssignedWorkDetailSchema,
});
exports.mobileAppointmentStatusErrorCodeV1Schema = zod_1.z.enum([
    "ASSIGNED_WORK_NOT_FOUND",
    "APPOINTMENT_ACTION_FORBIDDEN",
    "APPOINTMENT_ACTION_NOT_AVAILABLE",
    "REQUIRED_JOB_CHECKLIST_INCOMPLETE",
]);
exports.mobileJobChecklistErrorCodeV1Schema = zod_1.z.enum([
    "ASSIGNED_WORK_NOT_FOUND",
    "JOB_CHECKLIST_ITEM_NOT_FOUND",
    "JOB_CHECKLIST_ITEM_TYPE_MISMATCH",
    "JOB_CHECKLIST_LOCKED",
]);
//# sourceMappingURL=mobile-assigned-work.js.map